import styled from 'styled-components';

const StyledTransactionType = styled.span`
    span.plain-text {
        font-size: 85%;
        line-height: 1.25;
    }
`;

export { StyledTransactionType };
